import * as TFS_Host_TfsContext from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import { AnalyticsODataClientBase } from "TestManagement/Scripts/Scenarios/Analytics/AnalyticsODataClientBase";
import { ODataQueryOptions, OData, AnalyticsODataVersions } from "Analytics/Scripts/OData";

const TestResourceEntityNames = {
    Points: "TestPoints",
    Suites: "TestSuites"
}

const TestPointFieldNames = {
    PlanId: "TestPlanId",
}

export interface ITestResultsSummary {
    ExecPct: number;
    PassedPct: number;
    TotalCount: number;
}

export class TestPlanResultsSource {

    public getTestResultsSummary(planId: number): IPromise<ITestResultsSummary> {
        let filterStr = this._getFilterString(planId);
        let groupByStr = this._getGroupByStr();

        const queryOptions = {
            entityType: TestResourceEntityNames.Points,
            project: this._getProjectIdFromContext(),
            oDataVersion: AnalyticsODataVersions.latestODataVersion
        } as ODataQueryOptions;
        
        queryOptions.$apply = `${filterStr}/${groupByStr}`;

        return OData.query("ManualTestAnalytics_TestResultsReportSummary", queryOptions, 120000).then((oDataQueryResponse: any): Promise<ITestResultsSummary> => {
            return Promise.resolve(this._createTestResultsSummary(oDataQueryResponse));
        });
    }

    _getFilterString(planId: number): string {
        return `filter(${TestPointFieldNames.PlanId} eq ${planId})`;
    }

    private _getGroupByStr() {
        return `aggregate($count as TotalCount, 
        cast(LastResultOutcome eq 'Passed', Edm.Int32) with sum as Passed, 
        cast(LastResultOutcome eq 'None', Edm.Int32) with sum as NotExecuted,
        cast(LastResultOutcome ne 'None', Edm.Int32) with sum as Executed)/compute(Executed mul 100 div TotalCount as ExecPct,
        iif(TotalCount gt NotExecuted, Passed mul 100 div Executed,0) as PassedPct)`;
    }

    private _createTestResultsSummary(odataQueryResponse: any): ITestResultsSummary {

        var response: ITestResultsSummary = {
            ExecPct: 0,
            PassedPct: 0,
            TotalCount: 0
        } as ITestResultsSummary;

        if (!odataQueryResponse || !odataQueryResponse.value) {
            throw new Error("Data is empty");
        }

        odataQueryResponse.value.forEach((row: ITestResultsSummary) => {
                response.ExecPct = isNaN(row.ExecPct) ? 0 : row.ExecPct,
                response.PassedPct = isNaN(row.PassedPct) ? 0 : row.PassedPct,
                response.TotalCount = row.TotalCount
        });

        return response;
    }

    /**
     * Get project id from context
     */
    private _getProjectIdFromContext(): string {
        return TFS_Host_TfsContext.TfsContext.getDefault().contextData.project.id;
    }
}